import { Breadcrumbs } from "components/breadcrumbs";
import { useCreate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { IBlogForm } from "interfaces";
import { useNavigate } from "react-router-dom";
import { BlogForm } from "./components";

export const CreateBlog: React.FC = () => {

  const { mutate, isLoading: isSubmitingSubCategoryForm } = useCreate();
  const navigate = useNavigate();

  const onSubmit = (values: IBlogForm) => {
    const submitValues = { ...values };
    mutate(
      {
        resource: "mkt/blogs",
        meta: {
          ignoreResourceWrapper: true,
        },
        values: {
          ...submitValues,
        },
      },
      {
        onSuccess: () => {
          toast.success("Create successfully");
          navigate(`/mkt/blog`);
        },
      }
    );
  };

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Blog" />
      <BlogForm onSubmit={onSubmit} />
      {isSubmitingSubCategoryForm ? <FullScreenLoading /> : <></>}
    </div>
  );
};
